module.exports = __webpack_public_path__ + "img/lavar_mascara_green.0e26b63d.svg";